const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

export function paginateItems<T>(items: T[], page: number, pageSize: number) {
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize))
  const safePage = Math.min(Math.max(1, page), totalPages)
  const start = (safePage - 1) * pageSize
  return {
    items: items.slice(start, start + pageSize),
    totalPages,
    safePage,
    start,
    end: Math.min(start + pageSize, items.length),
  }
}

type PaginationControlsProps = {
  page: number
  pageSize: number
  totalItems: number
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export default function PaginationControls({
  page,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
}: PaginationControlsProps) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize))
  const safePage = Math.min(Math.max(1, page), totalPages)
  const start = totalItems === 0 ? 0 : (safePage - 1) * pageSize + 1
  const end = Math.min(safePage * pageSize, totalItems)

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 border-t border-white/[0.06] text-xs text-gray-500">
      <span>{start}-{end} de {totalItems}</span>
      <div className="flex items-center gap-2">
        <span>Itens por pagina</span>
        <select
          className="input-field"
          style={{ width: 92, padding: '5px 8px', fontSize: 12 }}
          value={pageSize}
          onChange={event => {
            onPageSizeChange(Number(event.target.value))
            onPageChange(1)
          }}
        >
          {PAGE_SIZE_OPTIONS.map(option => <option key={option} value={option}>{option} por pagina</option>)}
        </select>
        <button className="btn-ghost" disabled={safePage <= 1} onClick={() => onPageChange(safePage - 1)}>Anterior</button>
        <span>Pagina {safePage} de {totalPages}</span>
        <button className="btn-ghost" disabled={safePage >= totalPages} onClick={() => onPageChange(safePage + 1)}>Proxima</button>
      </div>
    </div>
  )
}
